export default __webpack_public_path__ + "static/more_info.png";